interface I_Params {
    device: 'PC' | 'M';
    mCloseBtn?: (isOpen: boolean) => void;
    travelType?: string | null;
}

export const createSearchPanel = ({ device, mCloseBtn, travelType }: I_Params) => {
    if (typeof window.SearchPanel !== 'function') {
        return;
    }
    new window.SearchPanel({
        panel: travelType && travelType === '2' ? 'groupfreeSearch' : 'travelSearch', // travelType 為 2 時顯示團體自由行引擎
        type: `${device === 'PC' ? 'pc_result' : 'm_result'}`,
        target: '_blank',
        rowSkin: true,
        mTitle: '搜尋引擎',
        mCloseBtn: function () {
            mCloseBtn && mCloseBtn(false);
        },
        searchPaneltDidMount: function () {
            // console.log('Search Panel ready!!');
        },
        whenSubmitBtnClick: function () {
            // console.log('when Submit Button on Click!!');
        },
        renderNode: `SearchPanel${device === 'M' ? 'M' : ''}`,
    });
};
